/**
 * Server settings (superadmin): call-server (ICE/TURN vs hosted provider)
 * and mail/payments credentials. Secret fields are write-only: stored
 * values are never displayed; leaving them blank keeps the current value.
 */

import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { Box } from '@mui/material';
import {
  SettingsPhoneOutlined as CallServerIcon,
  MailOutline as MailIcon,
} from '@mui/icons-material';
import { SubMenu } from '@/components/common';
import { CallServerForm } from './CallServerForm';
import { MailPaymentsForm } from './MailPaymentsForm';

export const ServerSettingsPage = () => {
  const translate = useTranslate();
  const [activeView, setActiveView] = useState('callserver');

  const tabs = [
    {
      value: 'callserver',
      label: translate('pages.serverSettings.tabs.callserver'),
      icon: <CallServerIcon />,
    },
    {
      value: 'mail',
      label: translate('pages.serverSettings.tabs.mail'),
      icon: <MailIcon />,
    },
  ];

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <SubMenu items={tabs} activeItem={activeView} onChange={setActiveView} />
      <Box sx={{ mt: 2, maxWidth: 640 }}>
        {activeView === 'callserver' && <CallServerForm />}
        {activeView === 'mail' && <MailPaymentsForm />}
      </Box>
    </Box>
  );
};

export default ServerSettingsPage;
